import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=d0239576&scoped=true&"
import script from "./mechanism.vue?vue&type=script&lang=js&"
export * from "./mechanism.vue?vue&type=script&lang=js&"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=d0239576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0239576",
  null
  
)

export default component.exports